<script>
import { mapState, mapActions } from "vuex";
import { id } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";

export default {
	name: "masterParokiForm",
	components: { Datepicker },
   data() {
		return {
			mode: "INSERT",
			// myData: {
			// 	keuskupan: "",
			// 	geraja: "",
			// 	paroki: "",
			// 	tahun_pendirian: "",
			// 	alamat: "",
			// 	alamat_singkat: "",
			// 	paroki_asal: "",
			// },
			show: true,
			showImages: false,
			message: "",
			myOptions: {
				status: [
					{ text: "-", value: null },
					{ text: "Aktif", value: 1 },
					{ text: "Non Aktif", value: 0 },
				],
				kabupaten: [],
			},
			params: {},
			headers: {},
			imgDataUrl: "",
         filterDateLang: id,
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			myData: (state) => state.masterParoki.data,
		}),
	},
	created() {
		this.$store.dispatch("masterParoki/getById");
		// console.log(this.myData);
	},
	mounted() {},
	methods: {
		// ...mapActions("pengguna", ["insert", "update"]),
		...mapActions({
			update: "masterParoki/update",
			getByID: "masterParoki/getById",
		}),
		onSubmit() {
			this.update(this.myData).then(() => {});
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs main="paroki" title="Form Paroki" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<form
								@submit.prevent="onSubmit"
								v-if="show"
								id="form-data"
							>
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label>Nama Keuskupan</label>
												<input
													v-model="myData.keuskupan"
													class="form-control"
													type="text"
													required
												/>
											</div>
											<div class="form-group">
												<label>Nama Paroki</label>
												<input
													v-model="myData.paroki"
													class="form-control"
													type="text"
													required
												/>
											</div>
											<div class="form-group">
												<label>Nama Geraja</label>
												<input
													v-model="myData.gereja"
													class="form-control"
													type="text"
													required
												/>
											</div>											
                                 <div class="form-group">
												<label>Paroki Asal</label>
												<input
													v-model="myData.paroki_asal"
													class="form-control"
													type="text"
													required
												/>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>Tahun</label>
												<datepicker
													v-model="myData.tahun_pendirian"
													input-class="datepicker-here form-control form-control-sm"
													:minimumView="'year'"
													:maximumView="'year'"
													format="yyyy"
													:language="filterDateLang"
												></datepicker>
											</div>
											<div class="form-group">
												<label>Alamat Singkat</label>
												<input
													v-model="myData.alamat_singkat"
													class="form-control"
													type="text"
												/>
											</div>
											<div class="form-group">
												<label>Alamat Lengkap</label>
												<input
													v-model="myData.alamat"
													class="form-control"
													type="text"
												/>
											</div>
										</div>
									</div>
									<hr />
									<div class="row">
										<div class="col">
											<div class="form-group mb-0">
												<b-button
													class="mr-3"
													type="submit"
													variant="primary"
													:disabled="isLoading"
													form="form-data"
												>
													<span
														v-show="isLoading"
														class="spinner-border spinner-border-sm"
													></span
													><i
														class="fa fa-fw fa-save"
														v-show="!isLoading"
													></i>
													Simpan
												</b-button>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</px-card>
				</div>
			</div>
		</div>
		<!-- Container-fluid Ends-->
	</div>
</template>

